import axios from 'axios';
import config from '../config';
import { saveAs } from 'file-saver';


const CancelToken = axios.CancelToken;
var source = CancelToken.source();

const TTEndPoint = axios.create({
	baseURL:  `${config.clientApi}`,
	timeout: 100000,
	headers: {
		'accept': 'application/json',
		'content-type': 'application/json'
	},
	cancelToken: source.token
});

const TTEmailEndPoint = axios.create({
	baseURL:  `${config.clientApi}`,
	timeout: 100000,
	headers: {
		'accept': 'application/json',
		'content-type': 'application/json'
	},
	cancelToken: source.token
});

const TTLongEndPoint = axios.create({
	baseURL:  `${config.clientApi}`,
	timeout: 100000,
	headers: {
		'accept': 'application/json',
		'content-type': 'application/json'
	},
	cancelToken: source.token
});

const TTLoginEndPoint = axios.create({
	baseURL: `${config.clientApi}`,
	headers: {
		'content-type': 'application/x-www-form-urlencoded'
	},
	cancelToken: source.token,
	timeout: 100000
});

const TTUploadEndPoint = axios.create({
	baseURL:  `${config.clientApi}`,
	timeout: 30000,
	headers: {
		'accept': 'multipart/form-data',
		'content-type': 'multipart/form-data'
	},
	cancelToken: source.token
});

const TTDownloadEndPoint = axios.create({
	baseURL:  `${config.clientApi}`,
	timeout: 30000,
	responseType: 'blob',
	cancelToken: source.token
});

const fakeSignIn = async (username,password) => {
	//source && source.cancel('Operation canceled due to new request.');
	//source = CancelToken.source();
	let response = {};
	try {

			response = await TTEndPoint.post('/dashboard/auth', {user: username, password: password},
				{withCredentials: true}
			);
			console.log('fake signin response', response);
		if (response.request.response.includes('Unable to login to the supplied account, please check your details and try again.')) {
			console.error("signIn error", response);
			return null;
		}
    return response;
	} catch (error) {
		response = error.response !== undefined ? error.response : error;
		console.error("fake signIn error", response);
    return null;
	}

};

const signIn = async (username,password) => {
	//source && source.cancel('Operation canceled due to new request.');
	//source = CancelToken.source();
	let response = {};
	try {
		response = await TTLoginEndPoint.post('/j_security_check',
                      `j_username=`+username+`&j_password=`+password+'&submit=Login',
                      {withCredentials: true});
											console.log('signin response', response);

		if (response.request.response.includes('Unable to login to the supplied account, please check your details and try again.')) {
			console.error("signIn error", response);
			return null;
		}
    return response;
	} catch (error) {
		response = error.response !== undefined ? error.response : error;
		console.error("signIn error", response);
    return null;
	}

};

const signOut = async () => {
	let response = {};
	try {
    //response = await TTEndPoint.get('/dashboard/logout');
		response = await TTEndPoint.post('/dashboard/logout');
    //response = await TTEndPoint.get('/index.jsp?logout');
	} catch (error) {
		response = error.response;
		console.error("signOut error", error.response);
	}
	return response;
};

const getWorkerTimesheets = async (uid) => {
	let response = {};
	try {
		response = await TTEndPoint.get('/timetracking/workers.json', {
			params: {
        'uid': uid
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getWorkerTimesheets error", error.response);
		response = null;
	}
	return response;
};

const getUserInfo = async (uid) => {
	let response = {};
	try {
		response = await TTEndPoint.get('/dashboard/user', {
			params: {
        'uid': uid
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.log(error);
		console.error("getUserInfo error", error.response);
		return null;
	}
	return response;
};

const getOpenJobs = async () => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/jobs',{withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("getOpenJobs error", error.response);
		return [];
	}
	return response.data;
};

const getOpenJobsByKey = async (key) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/jobs',{
			params: {
				'key': key
			},
			withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("getOpenJobs error", error.response);
		return [];
	}
	return response.data;
};



const getClosedJobs = async (key) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/jobs/closed',{
			params: {
        'key': key
			},
			withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("getClosedJobs error", error.response);
		return [];
	}
	return response.data;
};

const getCustomerOpenJobs = async (customerId) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/jobs',{
			params: {
        'customer_id': customerId
			},
			withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("getCustomerOpenJobs error", error.response);
		return [];
	}
	return response.data;
};

const getCustomerOpenJobsBykey = async (customerId,key) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/jobs',{
			params: {
				'key': key,
        'customer_id': customerId
			},
			withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("getCustomerOpenJobsBykey error", error.response);
		return [];
	}
	return response.data;
};

const getCustomerClosedJobs = async (customerId) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/jobs/closed',{
			params: {
        'customer_id': customerId
			},
			withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("getOpenJobs error", error.response);
		return [];
	}
	return response.data;
};

const getCustomerClosedJobsByKey = async (customerId, key) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/jobs/closed',{
			params: {
        'customer_id': customerId,
				'key': key
			},
			withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("getOpenJobs error", error.response);
		return [];
	}
	return response.data;
};

const getActiveCustomers = async () => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/customers',{withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("getActiveCustomers error", error.response);
	}
	return response;
};

const getFirstFewActiveCustomers = async (first) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/customers',{
			params: {
        'first': first
			},
			withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("getActiveCustomers error", error.response);
	}
	return response === undefined || response === null || response.data === null ? [] : response.data;
};

const getAllCustomers = async () => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/customers',{
			params: {
        'all': true
			},
			withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("getActiveCustomers error", error.response);
	}
	return response === undefined || response === null || response.data === null ? [] : response.data;
};

// use on the drodpwon search
const getCustomersByKey = async (key) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/customers', {
			params: {
        'key': key
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getCustomersByKey error", error.response);
    return [];
	}
	return response.data === null ? [] : response.data;
};

// use on the customer list
const getAllCustomersByKey = async (key) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/customers', {
			params: {
				'all': true,
        'key': key
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getCustomersByKey error", error.response);
    return [];
	}
	return response.data === null ? [] : response.data;
};

const getDefaultPricing = async () => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/default_pricing',{withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("getDefaultPricing error", error.response);
	}
	return response;
};

const getSitePricing = async (id) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/site_pricing', {
			params: {
        'id': id
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getSitePricing error", response ? error.response : error);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};

const getSitePricingByCustomerId = async (customerId) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/site_pricing', {
			params: {
        'customer_id': customerId
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getSitePricingByCustomerId error", response ? error.response : error);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};

const getSiteTestingScopesByCustomerId = async (customerId) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/site_testing_scopes', {
			params: {
        'customer_id': customerId
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getSiteTestingScopesByCustomerId error", response ? error.response : error);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};

const saveCustomer = async (data) => {
  let response = {};
  try {
		response = await TTEndPoint.post('/dashboard/customer', data, {withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("saveCustomer error", error.response);
	}
	return response;
};

const saveCustomerNotes = async (data) => {
  let response = {};
  try {
		response = await TTEndPoint.post('/dashboard/customer', data, {
			params: {
        'is_notes': true
			},
			withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("saveCustomerNotes error", error.response);
	}
	return response;
};

const getActiveSites = async () => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/sites',{withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("getActiveSites error", error.response);
	}
	return response;
};

const getCustomerSites = async (customerId) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/sites',{
			params: {
				'customer_id': customerId
		  },
		withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("getCustomerSites error", response ? error.response : error);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};

/*const getCustomerServices = async (customerId) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/customer_services',{
			params: {
				'id': customerId
		  },
		withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("getCustomerServices error", response ? error.response : error);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};*/

const getCustomerTestingScopes = async (customerId) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/customer_testing_scopes',{
			params: {
				'id': customerId
		  },
		withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("getCustomerTestingScopes error", response ? error.response : error);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};

const getSitesByKey = async (key, customerId) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/sites', {
			params: {
        'key': key,
				'customer_id': customerId
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getSitesByKey error", error.response);
    return [];
	}
	return response.data === null ? [] : response.data;
};

const getSiteAssetsExpiryByMonthSummary = async (id) => {
	let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/site_assets', {
			params: {
        'id': id,
				'is_expiry_by_month_summary': true
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getSiteAssetsExpiryByMonthSummary error", error.response);
    return [];
	}
	return response.data === null ? [] : response.data;

};

const saveSite = async (data) => {
  let response = {};
  try {
		response = await TTEndPoint.post('/dashboard/site', data, {withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("saveSite error", error.response);
	}
	return response;
};

const saveSiteNotes = async (data) => {
  let response = {};
  try {
		response = await TTEndPoint.post('/dashboard/site', data, {
			params: {
        'is_notes': true
			},
			withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("saveSiteNotes error", error.response);
	}
	return response;
};

const getSiteTestingScopes = async (siteId) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/site_testing_scopes',{
			params: {
				'id': siteId
		  },
		withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("getSiteTestingScopes error", response ? error.response : error);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};

const getRegions = async () => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/regions', {
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getRegions error", error.response);
    return [];
	}
	return response.data === null ? [] : response.data;
};

const getGeoRegions = async () => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/geo_regions', {
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getGeoRegions error", error.response);
    return [];
	}
	return response.data === null ? [] : response.data;
};

const getActiveWorkersByRegion = async (regionId) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/workers', {
			params: {
				'region_id': regionId
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getActiveWorkersByRegion error", error.response);
    return [];
	}
	return response.data === null ? [] : response.data;
};

const getActiveWorkers = async () => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/workers', {
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getActiveWorkers error", error.response);
    return [];
	}
	return response.data === null ? [] : response.data;
};

const getAllAccounts = async () => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/workers', {
			params: {
				'all': true
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getAllAccounts error", error.response);
    return [];
	}
	return response.data === null ? [] : response.data;
};

const getAllAccountsByKey = async (key) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/workers', {
			params: {
				'all': true,
				'key': key
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getAllAccountsByKey error", error.response);
    return [];
	}
	return response.data === null ? [] : response.data;
};

const getAllTestntelAccounts = async () => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/workers', {
			params: {
				'testntel_only': true
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getAllTestntelAccounts error", error.response);
    return [];
	}
	return response.data === null ? [] : response.data;
};

const getAllTestntelAccountsByKey = async (key) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/workers', {
			params: {
				'testntel_only': true,
				'key': key
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getAllAccountsByKey error", error.response);
    return [];
	}
	return response.data === null ? [] : response.data;
};

const getCustomerPortalAccounts = async () => {
  let response = {};

  try {
    response = await TTEndPoint.get('/dashboard/workers', {
      params: {
        'customer_portal': true
      },
      withCredentials: true
    });
  } catch (error) {
    response = error.response;
    console.error("getCustomerPortalAccounts error", error.response);
    return [];
  }

  return response.data === null ? [] : response.data;
};

const getCustomerPortalAccountsByKey = async (key) => {
  let response = {};

  try {
    response = await TTEndPoint.get('/dashboard/workers', {
      params: {
        'customer_portal': true,
        'key': key
      },
      withCredentials: true
    });
  } catch (error) {
    response = error.response;
    console.error("getCustomerPortalAccountsByKey error", error.response);
    return [];
  }

  return response.data === null ? [] : response.data;
};

const loadAccount = async (id) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/account', {
			params: {
				'id': id
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("loadAccount error", error.response);
    return [];
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};

const saveAccount = async (data) => {
  let response = {};
  try {
		response = await TTEndPoint.post('/dashboard/account', data, {withCredentials: true});
	} catch (error) {
		console.log(error);
		response = error.response;
		console.error("saveAccount error", error.response);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null)
				  ? {id:-1, error: ''}: {id:response.data.id, error: response.data.message};
};

const saveJob = async (data) => {
  let response = {};
  try {
		response = await TTEndPoint.post('/dashboard/job', data, {withCredentials: true});
	} catch (error) {
		console.log(error);
		response = error.response;
		console.error("saveJob error", error.response);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null)
				  ? {id:-1, error: ''}: {id:response.data.id, error: response.data.message};
};

const loadJob = async (jobId) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/job',{
			params: {
        'job_id': jobId
			},
			withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("loadJob error", error.response);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};

const getJobWorkerEmails = async (jobId) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/job/emails',{
			params: {
        'job_id': jobId
			},
			withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("getJobWorkerEmails error", error.response);
	}
	console.log(response);
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data.emails;
};

const deleteJob = async (jobId) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/job',{
			params: {
        'job_id': jobId,
				'delete': true
			},
			withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("deleteJob error", error.response);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null)
				  ? {id:-1, error: ''}: {id:response.data.id, error: response.data.message};
};

const copyJob = async (id) => {
  let response = {};
  try {
		response = await TTEndPoint.post('/dashboard/copy_job', null, {
			params: {
        'job_id': id
			},
			withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("copyJob error", error.response);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null)
					? -1: response.data.id;
};

const confirmJob = async (jobId) => {
  let response = {};
  try {
		response = await TTEndPoint.post('/dashboard/confirm_job', null, {
			params: {
        'id': jobId,
				'confirm': true
			},
			withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("confirmJob error", error.response);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null)
				  ? {success:-1, error: ''}: {success: response.data.success};
};

const getLastJobOnSite = async (id) => {
	let response = {};
  try {
		response = await TTEndPoint.post('/dashboard/last_job', null, {
			params: {
        'site_id': id
			},
			withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("getLastJobOnSite error", error.response);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null)
					? -1: response.data;
};

const getCustomerById = async (id) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/customer', {
			params: {
        'id': id
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getCustomerById error", response ? error.response : error);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};

const getSiteById = async (id) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/site', {
			params: {
        'id': id
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getSiteById error", response ? error.response : error);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};

const getRetestPredictions = async (isMonthly) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/retest_predictions', {
			params: {
	        'is_monthly': isMonthly
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getRetestPredictions error", error.response);
    return [];
	}
	return response.data === null ? [] : response.data;
};

/*const getRetests = async () => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/retests', {
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getRetests error", error.response);
    return [];
	}
	return response.data === null ? [] : response.data;
};*/


const getRetests = async (key, offset, limit, selectedCustomers, selectedSites,
	selectedRegions, selectedGeographicRegions, selectedGeographicLocalities,
	selectedStatuses, selectedArchived, selectedAssetType, selectedKpiCustomer, selectedKeyCustomer,
	from, to, sortByColumn, sortDirection) => {
	if (from === undefined || to === undefined || from === null || to === null) {
		console.log("no valid time provided, return[]");
		return null;
	}

	let response = {};
  //qs.stringify(xxx)
  try {
		response = await TTLongEndPoint.get('/dashboard/retests', {
			params: {
        'key': key,
				'offset': offset,
				'limit': limit,
				'selectedCustomers': selectedCustomers.join(),
				'selectedSites': selectedSites.join(),
				'selectedRegions': selectedRegions.join(),
				'selectedGeographicRegions': selectedGeographicRegions.join(),
				'selectedGeographicLocalities': selectedGeographicLocalities.join(),
				'selectedStatuses': selectedStatuses.join(),
				'selectedArchived': selectedArchived,
				'selectedAssetType': selectedAssetType,
				'selectedKpiCustomer': selectedKpiCustomer,
				'selectedKeyCustomer': selectedKeyCustomer,
				'from': from,
				'to': to,
				'sortByColumn': sortByColumn,
				'sortDirection': sortDirection
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;console.error(error)
		console.error("getRetests error", response ? error.response : error);
		return null;
	}
	return response.data;
};

const getSiteRetests = async (id) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/site_retests', {
			params: {
        'id': id
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getRetests error", error.response);
    return [];
	}
	return response.data === null ? [] : response.data;
};

const searchRetests = async (key) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/retests',{
			params: {
        'key': key,
				'is_quick_search': true
			},
			withCredentials: true});
	} catch (error) {console.log(error);
		response = error.response;
		console.error("searchRetests error", error.response);
		return [];
	}
	return response.data === null ? [] : response.data;
};

const loadRetest = async (id, siteId) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/retest', {
			params: {
        'id': id,
				'site_id': siteId
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("loadRetest error", response ? error.response : error);

	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};

const bookRetest = async (retestId, jobId) => {
  let response = {};
  try {
		response = await TTEndPoint.post('/dashboard/retest/book', null, {
			params: {
				'retestId': retestId,
        'jobId': jobId
			},
			withCredentials: true});
	} catch (error) {
		console.log(error);
		response = error.response;
		console.error("bookRetest error", error.response);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null)
					? -1: response.data;
};

const bookSiteRetest = async (siteId, jobId) => {
  let response = {};
  try {
		response = await TTEndPoint.post('/dashboard/site/retest/book', null, {
			params: {
				'siteId': siteId,
                'jobId': jobId
			},
			withCredentials: true});
	} catch (error) {
		console.log(error);
		response = error.response;
		console.error("bookSiteRetest error", error.response);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null)
					? -1: response.data;
};

const getTripHistoryAndDueRetestsFromRetest = async (retestId, maxDistanceKm = 50) => {
  let response = {};
  try {
    response = await TTEndPoint.get('/dashboard/retest/trip_context', {
      params: {
        retest_id: retestId,
        max_distance_km: maxDistanceKm
      },
      withCredentials: true
    });
  } catch (error) {
    response = error.response;
    console.error("getTripHistoryAndDueRetestsFromRetest error", response ? error.response : error);
    return null;
  }
  return response?.data ?? null;
};

const getRetestsForEmail = async (
  key,
  offset,
  limit,
  selectedRegions,
  selectedStatuses,
  selectedAssetType,
  from,
  to,
  selectedEmailActivity,
  emailDate,
	sortByColumn,
  sortDirection
) => {

	if (from === undefined || to === undefined || from === null || to === null) {
		console.log("no valid time provided, return[]");
		return null;
	}

	let response = {};
	try {
		response = await TTLongEndPoint.get('/dashboard/retest-email-list', {
			params: {
			  'key': key,
			  'offset': offset,
			  'limit': limit,
			  'selectedRegions': selectedRegions.join(),
			  'selectedStatuses': selectedStatuses.join(),
			  'selectedAssetType': selectedAssetType,
			  'emailActivity': selectedEmailActivity,
			  'from': from,
			  'to': to,
			  'emailDate': emailDate,
				'sortByColumn': sortByColumn,
  			'sortDirection': sortDirection
			},
			withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getRetestsForEmail error", response ? error.response : error);
		return null;
	}
	return response.data;
};

const updateRetestEmailFields = async (siteId, emailTo, greetingName) => {
	let response = {};
	try {
		response = await TTEndPoint.post('/dashboard/retest/email_fields', null, {
			params: {
				'site_id': siteId,
				'email_to': emailTo,
				'greeting_name': greetingName
			},
			withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("updateRetestEmailFields error", response ? error.response : error);
		return null;
	}
	return response.data;
};

const sendRetestEmail = async (retestIds, messageType, body, sendRetestEmail) => {
	let response = {};
	try {
		response = await TTEmailEndPoint.post('/dashboard/retest/send_email', {
			retestIds: retestIds,
			messageType: messageType,
			body: body,
			fromEmail: sendRetestEmail
		}, {
			withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("sendRetestEmail error", response ? error.response : error);
		return null;
	}
	return response.data;
};

const emailJobReport = async (data) => {
  let response = {};
  try {
		response = await TTEmailEndPoint.post('/dashboard/email_job_report', data, {withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("emailJobReport error", response ? error.response : error);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};

const getHistoricalJobNotes = async (id) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/historical_job_notes', {
			params: {
        'id': id
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getHistoricalJobNotes error", error.response);
    return [];
	}
	return response.data === null ? [] : response.data;
};

const getHistoricalJobNote = async (id) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/historical_job_note', {
			params: {
        'id': id
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getHistoricalJobNote error", response ? error.response : error);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};

const getHistoricalJobs = async (id) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/historical_jobs', {
			params: {
        'id': id
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getHistoricalJobs error", error.response);
    return [];
	}
	return response.data === null ? [] : response.data;
};

const getHistoricalJob = async (id) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/historical_job', {
			params: {
        'id': id
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getHistoricalJob error", response ? error.response : error);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};

const uploadSitePolicy = async (customerId, data) => {
  let response = {};
  try {
		response = await TTUploadEndPoint.post(`/policy?cid=${customerId}`, data, {withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("uploadSitePolicy error", error);
		return false;
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null)
					? false :  response.data.ok === 'true';
};

const uploadOtherDocuments = async (customerId, data) => {
  let response = {};
  try {
		response = await TTUploadEndPoint.post(`/dashboard/customer_documents?cid=${customerId}`, data, {withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("uploadOtherDocuments error", error);
		return false;
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null)
					? false :  response.data.ok === 'true';
};

const uploadMetrelResults = async (jobId, userId, from, to, useTimeRange, data) => {
  let response = {};
  try {
		response = await TTUploadEndPoint.post(`/metrel/upload/results?jid=${jobId}&uid=${userId}${useTimeRange ? `&from=${from}&to=${to}` : ''}`, data, {withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("uploadMetrelResults error", error);
		return false;
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null)
					? false :  response.data.ok === 'true';
};

const uploadMetrelCustomTests = async (data) => {
  let response = {};
  try {
		response = await TTUploadEndPoint.post(`/metrel/upload/custom_tests`, data, {withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("uploadMetrelCustomTests error", error);
		return false;
	}
	return response;
};

const deleteDocument = async (docId) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/customer_documents',{
			params: {
        'id': docId,
				'delete': true
			},
			withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("deleteDocument error", error.response);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null)
				  ? {id:-1, error: ''}: {id:response.data.id, error: response.data.message};
};

const uploadAccountPhoto = async (id, data) => {console.log('uploadAccountPhoto',id)
  let response = {};
  try {
		response = await TTUploadEndPoint.post(`/dashboard/account/upload?id=${id}`, data, {withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("uploadAccountPhoto error", error);
		return false;
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null)
					? false :  response.data.ok;
};

/*const getAssets = async (key, offset, cid, status) => {
  let response = {};
  try {
		response = await TTLongEndPoint.get('/dashboard/assets', {
			params: {
        'key': key,
				'offset': offset,
				'cid': cid,
				'status': status
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getAssets error", response ? error.response : error);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};*/

const getAssets = async (cid, key, offset, limit, selectedTypes, selectedSites, selectedPassed, selectedDisposed, from, to, sortByColumn, sortDirection) => {
  let response = {};
  //qs.stringify(xxx)
  try {
		response = await TTLongEndPoint.get('/dashboard/assets', {
			params: {
				'cid': cid,
        'key': key,
				'offset': offset,
				'limit': limit,
				'selectedTypes': selectedTypes.join(),
				'selectedSites': selectedSites.join(),
				'selectedPassed': selectedPassed.join(),
				'selectedDisposed': selectedDisposed.join(),
				'from': from,
				'to': to,
				'sortByColumn': sortByColumn,
				'sortDirection': sortDirection
			},
            withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getAssets error", response ? error.response : error);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};

const loadAsset = async (assetId) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/asset',{
			params: {
        'id': assetId
			},
			withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("loadAsset error", error.response);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};

const getDisposalCodes = async () => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/disposal_codes', {
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getDisposalCodes error", error.response);
    return [];
	}
	return response.data === null ? [] : response.data;
};

const saveAsset = async (data) => {
  let response = {};

  try {
    response = await TTEndPoint.post('/dashboard/asset', data, { withCredentials: true });
  } catch (error) {
    response = error.response;
    console.error("saveAsset error", error.response);
  }

  return (response === undefined || response == null ||
          response.data === undefined || response.data === null)
    ? { error: "true", message: "Error - updating asset." }
    : response.data;
};

const completeJob = async (id) => {
  let response = {};
  try {
		response = await TTEndPoint.post('/dashboard/complete_job', null, {
			params: {
        'id': id
			},
			withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("completeJob error", error.response);
	}console.log(response);
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null)
					? false: response.data;
};

const reopenJob = async (id) => {
  let response = {};
  try {
		response = await TTEndPoint.post('/dashboard/job/reopen', null, {
			params: {
        'id': id
			},
			withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("reopenJob error", error.response);
	}console.log(response);
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null)
					? false: response.data;
};

const getInvoicingSummary = async (jobId) => {
  let response = {};
  try {
		response = await TTLongEndPoint.get('/dashboard/invoicing_summary', {
			params: {
        'jobId': jobId
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getInvoicingSummary error", response ? error.response : error);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};

const resetXeroContact = async (customerId) => {
  let response = {};
  try {
		response = await TTUploadEndPoint.post('/dashboard/customer/reset_xero', null, {
			params: {
        'id': customerId
			},
			withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("resetXeroContact error", error);
		return false;
	}
	console.log(response);
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null)
					? false :  response.data.ok;
};

const getWorkersSchedules = async () => {
	let response = {};
  try {
		response = await TTUploadEndPoint.get('/dashboard/workers/schedules',
			{withCredentials: true}
		);
	} catch (error) {
		response = error.response;
		console.error("getWorkersSchedules error", error);
		return false;
	}
	console.log(response);
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null)
					? [] :  response.data;
};

const getWorkerSchedules = async (accountId) => {
	let response = {};
  try {
		response = await TTUploadEndPoint.get('/dashboard/workers/schedules', {
			params: {
        'account_id': accountId
			},
			withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getWorkerSchedules error", error);
		return false;
	}
	console.log(response);
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null)
					? [] :  response.data;
};


const getDescriptionsByKey = async (key) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/descriptions', {
			params: {
        'key': key
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getDescriptionsByKey error", error.response);
    return [];
	}
	return response.data === null ? [] : response.data;
};

const getServices = async () => {
	let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/services', {
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getServices error", error.response);
    return [];
	}
	return response.data === null ? [] : response.data;
};

const getTestingScopes = async () => {
	let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/testing_scopes', {
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getTestingScopes error", error.response);
    return [];
	}
	return response.data === null ? [] : response.data;
};

const sendJobSheet = (jobId) => {
	let response = {};
	try {
		response = TTEndPoint.get(`/reports/job_sheet.pdf?jobId=${jobId}&isEmail=true&isJobConfirmed=true`, {
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("sendJobSheet error", error.response);
		response = null;
	}
	return response;
};

const getTechnicianSettingsSetups = async () => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/technician_settings_setups', {
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getTechnicianSettingSetups error", response ? error.response : error);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};

const getAllUIRetestStatus = async () => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/retest_status/ui', {
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getRetestStatus error", response ? error.response : error);
		return null;
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};

const saveRetest = async (data) => {console.log("saveRetest",data);
  let response = {};
  try {
		response = await TTEndPoint.post('/dashboard/retest/edit', data, {withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("saveRetest error", error.response);
	}
	return response;
};

const updateRetestEmailTotalAssets = async (id, emailTotalAssets) => {
  let response = {};
  try {
    response = await TTEndPoint.post(
      '/dashboard/retest/email_total_assets',
      {
        id: id,
        email_total_assets: emailTotalAssets,
      },
      { withCredentials: true }
    );
  } catch (error) {
    response = error.response;
    console.error("updateRetestEmailTotalAssets error", error.response);
  }
  return response;
};

const getRetestCustomers = async (selectedStatuses, selectedArchived) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/retest/customers', {
			params: {
				'selectedStatuses': selectedStatuses.join(),
				'selectedArchived': selectedArchived
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getRetestCustomers error", response ? error.response : error);
		return [];
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? []: response.data;
};

const getRetestSites = async (selectedStatuses, selectedArchived, selectedCustomers) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/retest/sites', {
			params: {
				'selectedCustomers': selectedCustomers.join(),
				'selectedStatuses': selectedStatuses.join(),
				'selectedArchived': selectedArchived
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getRetestSites error", response ? error.response : error);
		return [];
	}console.log(response);
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? []: response.data;
};


const getRetestGeoRegions = async () => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/retest/geo_regions', {
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getRetestGeoRegions error", response ? error.response : error);
		return [];
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? []: response.data;
};

const getRetestGeoLocalities = async () => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/retest/geo_localities', {
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getRetestGeoLocalities error", response ? error.response : error);
		return [];
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? []: response.data;
};


const getRetestRegions = async () => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/retest/regions', {
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getRetestRegions error", response ? error.response : error);
		return [];
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? []: response.data;
};

const downloadRetestsSheet = async (key, offset, limit, selectedCustomers, selectedSites, selectedRegions, selectedGeographicRegions, selectedGeographicLocalities, selectedStatuses, selectedArchived, selectedAssetType, selectedKpiCustomer, selectedKeyCustomer, from, to, sortByColumn, sortDirection) => {
	if (from === undefined || to === undefined || from === null || to === null) {
		console.log("no valid time provided, return[]");
		return null;
	}

	let response = {};
  //qs.stringify(xxx)
  try {
		response = await TTDownloadEndPoint.get('/reports/retests', {
			params: {
        'key': key,
				'offset': offset,
				'limit': limit,
				'selectedCustomers': selectedCustomers.join(),
				'selectedSites': selectedSites.join(),
				'selectedRegions': selectedRegions.join(),
				'selectedGeographicRegions': selectedGeographicRegions.join(),
				'selectedGeographicLocalities': selectedGeographicLocalities.join(),
				'selectedStatuses': selectedStatuses.join(),
				'selectedArchived': selectedArchived,
				'selectedAssetType': selectedAssetType,
				'selectedKpiCustomer': selectedKpiCustomer,
				'selectedKeyCustomer': selectedKeyCustomer,
				'from': from,
				'to': to,
				'sortByColumn': sortByColumn,
				'sortDirection': sortDirection
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;console.error(error)
		console.error("getRetests error", response ? error.response : error);
	}
	// Log somewhat to show that the browser actually exposes the custom HTTP header
			console.log(response);
        const filename = response.headers['content-type'] ?
										(response.headers['content-type'].split('name=').length === 2 ?
												response.headers['content-type'].split('name=')[1] : 'retests.xls') : 'retests.xls';

        // Let the user save the file.
        saveAs(response.data, filename);
};

const getAssetReadableResultsAndType = async (aid) => {
	let response = {};
	try {
		response = await TTEndPoint.get('/timetracking/asset.json', {
			params: {
        'aid': aid
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getAssetReadableResults error", error.response);
		response = null;
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
					response.data.results === undefined || response.data.results === null ||
				  response.data.error)
					? null : [response.data.results, response.data.asset_details.tester_type, response.data.asset_details.is_formtab];
};

const getJobTestingScopes = async (jobId) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/job_testing_scopes',{
			params: {
				'id': jobId
		  },
		withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("getJobTestingScopes error", response ? error.response : error);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};

const saveCPI = async (data) => {
  let response = {};
  try {
		response = await TTEndPoint.post('/dashboard/cpi', data, {withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("saveCPI error", error.response);
	}
	return response;
};

const getCPI = async (id) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/cpi', {
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getCPI error", response ? error.response : error);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};

const updateCustomerPricingWithCPI = async (id) => {
  let response = {};
  try {
		response = await TTEndPoint.post('/dashboard/customer_cpi/pricing',null, {
			params: {
        'id': id
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("updateCustomerPricingWithCPI error", error.response);
	}
	return response;
};

const getCustomerCPI = async (id) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/customer_cpi', {
			params: {
        'id': id
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getCustomerCPI error", response ? error.response : error);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};

const getInsights = async (type) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/insights', {
			params: {
        'type': type
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getInsights error", response ? error.response : error);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};

const deleteRefund = async (refundId) => {
  let response = {};
  try {
		response = await TTEndPoint.post('/dashboard/refund', null, {
			params: {
        'refund_id': refundId,
				'delete': true
			},
			withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("deleteRefund error", error.response);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null)
				  ? {id:-1, error: ''}: {id:response.data.id, error: response.data.message};
};

const approveRefund = async (refundId) => {
  let response = {};
  try {
		response = await TTEndPoint.post('/dashboard/refund', null, {
			params: {
        'refund_id': refundId,
				'approve': true
			},
			withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("deleteRefund error", error.response);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null)
				  ? {id:-1, error: ''}: {id:response.data.id, error: response.data.message};
};

const deleteRefunds = async (refundIds) => {
  let response = {};
  try {
		response = await TTEndPoint.post('/dashboard/refunds', null, {
			params: {
        'refund_ids': refundIds,
				'delete': true
			},
			withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("deleteRefunds error", error.response);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null)
				  ? {error: ''}: {success:response.data.success, error: response.data.message};
};

const approveRefunds = async (refundIds) => {
  let response = {};
  try {
		response = await TTEndPoint.post('/dashboard/refunds', null, {
			params: {
        'refund_ids': refundIds,
				'approve': true
			},
			withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("approveRefunds error", error.response);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null)
				  ? {error: ''}: {success:response.data.success, error: response.data.message};
};

const getRefunds = async (start, end) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/refunds', {
			params: {
        'start': start,
				'end': end
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getInsights error", response ? error.response : error);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};

const updateRefund = async (data) => {
  let response = {};
  try {
		response = await TTEndPoint.post('/dashboard/refund/edit', data, {withCredentials: true});
	} catch (error) {
		response = error.response;
		console.error("updateRefund error", error.response);
	}
	return response;
};

const getRefundTypes = async () => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/refund_types', {
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getRefundTypes error", error.response);
    return [];
	}
	return response.data === null ? [] : response.data;
};

const getRefundCategories = async () => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/refund_categories', {
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("getRefundCategories error", error.response);
    return [];
	}
	return response.data === null ? [] : response.data;
};

const fetchTechnicalReportStatus = async (jobId) => {
  let response = {};
  try {
		response = await TTEndPoint.get('/dashboard/technical_reports', {
			params: {
        'jid': jobId
			},
      withCredentials: true
		});
	} catch (error) {
		response = error.response;
		console.error("fetchTechnicalReportStatus error", response ? error.response : error);
	}
	return (response === undefined || response == null ||
		      response.data === undefined || response.data === null ||
				  response.data.error)
					? null: response.data;
};

const deleteTechnicalReport = async (jobId, type) => {
  let response = {};
  try {
    response = await TTEndPoint.delete('/dashboard/technical_reports', {
      params: {
        'jobId': jobId,
        'type': type // expected values: 'pdf' or 'doc' or 'docx'
      },
      withCredentials: true
    });
  } catch (error) {
    response = error.response;
    console.error("deleteTechnicalReport error", response ? error.response : error);
  }

  return (response === undefined || response == null ||
          response.data === undefined || response.data === null ||
          response.data.error)
          ? null : response.data;
};

const uploadJobReports = async (jobId, data) => {
  let response = {};
  try {
    response = await TTUploadEndPoint.post(`/dashboard/technical_reports?jid=${jobId}`, data, {
      withCredentials: true
    });
  } catch (error) {
    response = error.response;
    console.error("uploadJobReports error", error);
    return false;
  }

  return (response === undefined || response == null ||
          response.data === undefined || response.data === null)
          ? false : response.data.success;
};

const getRetestVisitPatternSummary = async (retestId) => {
  let response = {};
  try {
    response = await TTEndPoint.get('/dashboard/retest/visit_pattern', {
      params: {
        'retest_id': retestId
      },
      withCredentials: true
    });
  } catch (error) {
    response = error.response;
    console.error("getRetestVisitPatternSummary error", response ? error.response : error);
    return null;
  }

  return (response === undefined || response == null ||
          response.data === undefined || response.data === null ||
          response.data.error)
          ? null : response.data;
};

const getIndustryCategories = async () => {
  let response = {};
  try {
    response = await TTEndPoint.get('/dashboard/industry-category', {
      withCredentials: true
    });
  } catch (error) {
    response = error.response;
    console.error("getIndustryCategories error", error.response);
    return [];
  }
  return response.data === null ? [] : response.data;
};

const getSchedulingChecklist = async (siteId, customerId, assetCoverageYearMonth, jobId = null) => {
  let response = {};
  try {
    response = await TTEndPoint.get('/dashboard/scheduling_checklist', {
      params: {
        site_id: siteId,
        customer_id: customerId,
        asset_coverage_year_month: assetCoverageYearMonth,
        job_id: jobId
      },
      withCredentials: true
    });
  } catch (error) {
    response = error.response;
    console.error("getSchedulingChecklist error", response ? error.response : error);
    return null;
  }

  return (response === undefined || response == null ||
          response.data === undefined || response.data === null ||
          response.data.error)
          ? null : response.data;
};

const saveSchedulingChecklistItem = async (data) => {
  let response = {};

  try {
    response = await TTEndPoint.post(
      '/dashboard/scheduling_checklist',
      data,
      {
        params: {
          site_id: data.site_id,
          job_id: data.job_id,
          template_key: data.template_key,
          asset_coverage_year_month: data.asset_coverage_year_month,
          is_completed: data.is_completed
        },
        withCredentials: true
      }
    );
  } catch (error) {
    response = error.response;
    console.error("saveSchedulingChecklistItem error", response ? error.response : error);
    return null;
  }

  return (
    response === undefined ||
    response == null ||
    response.data === undefined ||
    response.data === null ||
    response.data.error
  )
    ? null
    : response.data;
};

const getCurrentCustomerPolicy = async (customerId) => {
  let response = {};
  try {
    response = await TTEndPoint.get('/api/customer-policy', {
      params: { customer_id: customerId },
      withCredentials: true
    });
  } catch (error) {
    response = error.response;
    console.error("getCurrentCustomerPolicy error", response ? response : error);
    return null;
  }
  return response?.data ?? null;
};

const getCustomerPolicyHistory = async (customerId) => {
  let response = {};
  try {
    response = await TTEndPoint.get('/api/customer-policy', {
      params: {
        action: 'history',
        customer_id: customerId
      },
      withCredentials: true
    });
  } catch (error) {
    response = error.response;
    console.error("getCustomerPolicyHistory error", response ? response : error);
    return [];
  }
  return response?.data ?? [];
};

const getCustomerPolicyVersion = async (versionId) => {
  let response = {};
  try {
    response = await TTEndPoint.get('/api/customer-policy', {
      params: { version_id: versionId },
      withCredentials: true
    });
  } catch (error) {
    response = error.response;
    console.error("getCustomerPolicyVersion error", response ? response : error);
    return null;
  }
  return response?.data ?? null;
};

const createCustomerPolicyVersion = async (policy) => {
  let response = {};
  try {
    response = await TTEndPoint.post('/api/customer-policy', null, {
      params: {
        customer_id: policy.customer_id,
        change_reason: policy.change_reason,
				policy_title: policy.policy_title,
        scheduler_duties: policy.scheduler_duties,
        technician_duties: policy.technician_duties,
        scope_test_only: policy.scope_test_only,
        scope_do_not_test: policy.scope_do_not_test,
				scope_service_provided_heading: policy.scope_service_provided_heading,
				scope_service_not_provided_heading: policy.scope_service_not_provided_heading,
				test_interval_3_months: policy.test_interval_3_months,
				test_interval_6_months: policy.test_interval_6_months,
				test_interval_1_year: policy.test_interval_1_year,
				test_interval_2_years: policy.test_interval_2_years,
				test_interval_5_years: policy.test_interval_5_years,
				failed_item_policy: policy.failed_item_policy,
      },
      withCredentials: true
    });
  } catch (error) {
    response = error.response;
    console.error("createCustomerPolicyVersion error", response ? response : error);
    return null;
  }
  return response?.data ?? null;
};

const setCurrentCustomerPolicy = async (customerId, policyVersionId) => {
  let response = {};
  try {
    response = await TTEndPoint.post('/api/customer-policy', null, {
      params: {
        action: 'set_current',
        customer_id: customerId,
        policy_version_id: policyVersionId
      },
      withCredentials: true
    });
  } catch (error) {
    response = error.response;
    console.error("setCurrentCustomerPolicy error", response ? response : error);
    return null;
  }
  return response?.data ?? null;
};

const globalSearch = async (key) => {
  let response = {};

  try {
    response = await TTEndPoint.get('/dashboard/search', {
      params: {
        'key': key
      },
      withCredentials: true
    });
  } catch (error) {
    response = error.response;
    console.error("globalSearch error", error.response);
    return {
      customers: [],
      sites: [],
      accounts: []
    };
  }

  return response === undefined ||
         response === null ||
         response.data === undefined ||
         response.data === null
    ? {
        customers: [],
        sites: [],
        accounts: []
      }
    : response.data;
};




const TestTagAPI = {
	signIn,
  signOut,
  getWorkerTimesheets,
  getUserInfo,
  getOpenJobs,
	getOpenJobsByKey,
	getClosedJobs,
	getCustomerOpenJobs,
	getCustomerOpenJobsBykey,
	getCustomerClosedJobs,
	getCustomerClosedJobsByKey,
	saveJob,
	loadJob,
	deleteJob,
	confirmJob,
	getJobWorkerEmails,
	emailJobReport,
	getHistoricalJobNotes,
	getHistoricalJobNote,
	getHistoricalJobs,
	getHistoricalJob,
	completeJob,
	reopenJob,
  getActiveCustomers,
	getFirstFewActiveCustomers,
	getAllCustomers,
	getAllCustomersByKey,
  getCustomersByKey,
	getDefaultPricing,
	getSitePricing,
	getSitePricingByCustomerId,
	getSiteTestingScopesByCustomerId,
	saveCustomer,
	saveCustomerNotes,
	getActiveSites,
  getSitesByKey,
	getSiteTestingScopes,
	saveSite,
	saveSiteNotes,
	getRegions,
	getGeoRegions,
	getActiveWorkersByRegion,
	getActiveWorkers,
	getAllAccounts,
	getAllAccountsByKey,
	getAllTestntelAccounts,
	getAllTestntelAccountsByKey,
	getCustomerPortalAccounts,
	getCustomerPortalAccountsByKey,
	loadAccount,
	saveAccount,
	getCustomerById,
	getSiteById,
	getRetestPredictions,
	getRetests,
	getSiteRetests,
	searchRetests,
	loadRetest,
	saveRetest,
	updateRetestEmailTotalAssets,
	bookRetest,
	bookSiteRetest,
	fakeSignIn,
	uploadSitePolicy,
	uploadOtherDocuments,
	uploadAccountPhoto,
	uploadMetrelResults,
	uploadMetrelCustomTests,
	getAssets,
	loadAsset,
	saveAsset,
  getDisposalCodes,
	getCustomerSites,
	//getCustomerServices,
	getCustomerTestingScopes,
	copyJob,
	getSiteAssetsExpiryByMonthSummary,
	getInvoicingSummary,
	resetXeroContact,
	getLastJobOnSite,
	getWorkerSchedules,
	getWorkersSchedules,
	getDescriptionsByKey,
	getServices,
	getTestingScopes,
	deleteDocument,
	sendJobSheet,
	getTechnicianSettingsSetups,
	getRetestCustomers,
	getRetestSites,
	getRetestGeoRegions,
	getRetestGeoLocalities,
	getRetestRegions,
	getAllUIRetestStatus,
	downloadRetestsSheet,
	getAssetReadableResultsAndType,
	getJobTestingScopes,
	saveCPI,
	getCPI,
	updateCustomerPricingWithCPI,
	getCustomerCPI,
	getInsights,
	deleteRefund,
	approveRefund,
	deleteRefunds,
	approveRefunds,
	getRefunds,
	updateRefund,
	getRefundTypes,
	getRefundCategories,
	fetchTechnicalReportStatus,
	deleteTechnicalReport,
	uploadJobReports,
	getRetestsForEmail,
	updateRetestEmailFields,
	sendRetestEmail,
	getTripHistoryAndDueRetestsFromRetest,
	getRetestVisitPatternSummary,
	getIndustryCategories,
	getSchedulingChecklist,
  saveSchedulingChecklistItem,
	getCurrentCustomerPolicy,
	getCustomerPolicyHistory,
	getCustomerPolicyVersion,
	createCustomerPolicyVersion,
	setCurrentCustomerPolicy,
	globalSearch
};

export default TestTagAPI;
